/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/yaml-json-repl/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _helpers=__webpack_require__(1);var _styles=__webpack_require__(2);var _styles2=_interopRequireDefault(_styles);var _registerServiceWorker=__webpack_require__(3);var _registerServiceWorker2=_interopRequireDefault(_registerServiceWorker);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _window=window,CodeMirror=_window.CodeMirror,jsyaml=_window.jsyaml;/**
 * Shared editor options.
 *
 * @const {Object}
 */var editorOptions={inputStyle:'contenteditable',lineNumbers:true,lineWrapping:true,theme:'default'};/**
 * YAML CodeMirror editor instance (left).
 *
 * @const {Object}
 */var editor1=CodeMirror.fromTextArea(document.getElementById('editor1'),_extends({},editorOptions,{autofocus:true,gutters:['CodeMirror-lint-markers'],lint:true,mode:'yaml',styleActiveLine:true,tabSize:2}));/**
 * JSON CodeMirror editor instance (right).
 *
 * @const {Object}
 */var editor2=CodeMirror.fromTextArea(document.getElementById('editor2'),_extends({},editorOptions,{mode:'javascript',readOnly:true}));/**
 * JSON CodeMirror editor element.
 *
 * @const {HTMLDivElement}
 */var editor2Element=editor2.getWrapperElement();/**
 * Add extra keys to YAML editor.
 *
 * @const {Object}
 */editor1.setOption('extraKeys',{/**
   * Subtracts 2 spaces.
   *
   * @see {@link https://gist.github.com/danieleds/326903084a196055a7c3 Gist}
   * @param {CodeMirror} cm
   */'Shift-Tab':function ShiftTab(cm){cm.indentSelection('subtract');},/**
   * Indents with 2 spaces instead of tab.
   *
   * @see {@link https://gist.github.com/danieleds/326903084a196055a7c3 Gist}
   * @param {CodeMirror} cm
   */Tab:function Tab(cm){var selection=cm.somethingSelected()?editor1.getSelection('\n'):'';if(selection.length&&selection.indexOf('\n')!==-1||selection.length===cm.getLine(cm.getCursor().line).length){return cm.indentSelection('add');}editor1.execCommand('insertSoftTab');}});/**
 * Convert YAML to JSON on editor change and display errors if thrown.
 */editor1.on('change',function(cm){var value=cm.getValue();if(!value.trim()){(0,_helpers.removeClass)(editor2Element,_styles2.default.error);editor2.setValue('');return;}try{var js=jsyaml.load(cm.getValue());var json=JSON.stringify(js,null,2);(0,_helpers.removeClass)(editor2Element,_styles2.default.error);editor2.setValue(json);}catch(error){(0,_helpers.addClass)(editor2Element,_styles2.default.error);editor2.setValue((0,_helpers.capitalize)(error.message));}});(0,_registerServiceWorker2.default)();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/**
 * Adds CSS class to an element.
 *
 * @param {HTMLElement} element
 * @param {String}      className
 */var addClass=exports.addClass=function addClass(element,className){if(element.classList){element.classList.add(className);}else{var classes=element.className.split(' ');if(classes.indexOf(className)!==-1){classes.push(className);element.className=classes.join(' ');}}};/**
 * Removes CSS class from an element.
 *
 * @param {HTMLElement} element
 * @param {String}      className
 */var removeClass=exports.removeClass=function removeClass(element,className){if(element.classList){element.classList.remove(className);}else{var classes=element.className.split(' ');var classNameIndex=classes.indexOf(className);if(classNameIndex!==-1){classes.splice(classNameIndex,1);element.className=classes.join(' ');}}};/**
 * Capitalizes a string.
 *
 * @param  {String} string
 * @return {String}
 */var capitalize=exports.capitalize=function capitalize(string){return string[0].toUpperCase()+string.slice(1);};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"error":"error"};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=register;exports.unregister=unregister;/* eslint-disable no-console */// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/yaml-json-repl",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets.
return;}window.addEventListener('load',function(){var swUrl="/yaml-json-repl"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.b8ba6559.js